import { EVENTS as PDPEvents, bus as EventBus } from '../../components/product/bootstrap';
import { debounce } from '@city-mattress/js-utils';
import Splide from '../carousel';


const enableZoom = document.currentScript?.getAttribute('data-enable-zoom') === 'true';
console.log('enableZoom', enableZoom);

const galleryContainer = document.getElementById('ProductDisplayPageMainGalleryCarousel');

let carouselMounted: boolean = false;
let carousel: Splide | null = null;




const loadCarousel = () => {
	carouselMounted = true;
	let carousel = new Splide(galleryContainer, {
		perPage: 1,
		perMove: 1,
		pagination: true,
		arrows: true,
		padding: 0,
		gap: '16px',
	});
	carousel.mount();
	return carousel;
};


//Initialize the carousel
const init = () => {
	if (window.matchMedia('(max-width: 1024px)').matches && !carouselMounted) {
		carousel = loadCarousel();
	}
};


//DOM has been updated, let's rewire
EventBus.subscribe(PDPEvents.SECTION_UPDATED, function() {
	if(carouselMounted) {
		carousel.destroy();
		carousel = null;
		carouselMounted = false;
	}
	init();
});


window.addEventListener('resize', debounce(init, 100));



init();
